import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Filter from "../../components/Filter";
import Introduction from "../../components/Introduction";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import Document from "./Document";
import { useState } from "react";
import "./DocumentsPage.css";
import Loader from "../../components/Loader";

const DocumentsPage = () => {
  //definice stavů
  const [filterParameters, setFilterParameters] = useState("");

  //stavy pro predchozi filtrovani a nebo nastaveni popisku
  const [categoryLabel, setCategoryLabel] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/documents-page?populate=background`);

  //fetch kategorii pro filtr
  const {
    loading: loadingCategories,
    error: errorCategories,
    data: dataCategories,
  } = useFetch(`${config.api}/api/documents-categories`);

  //fetch dokumentů (populate pro jmena kategorii a media[soubor])
  const { loading, error, data } = useFetch(
    `${config.api}/api/documents?populate[0]=documentCategory&populate[1]=file${filterParameters}`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (!dataIntroduction || !dataIntroduction.data)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loadingCategories) return <Loader />;
  if (errorCategories)
    return <DefaultPage message="Chyba při načítání kategorií" />;
  if (!dataCategories || !dataCategories.data)
    return <DefaultPage message="Chyba při načítání kategorií" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání dokumentů" />;

  if (!data || !data.data)
    return <DefaultPage message="Žádné dokumenty k zobrazení" />;

  //? test
  //? console.log(data.data);
  //? console.log(dataCategories);

  //metoda filtru - po submitu tlacitkem se předají stavy textu a kategorie do url pro strapi filtr
  const handleFilterSubmit = ({ searchTerm, selectedCategory }) => {
    let parametersURL = "&";
    if (searchTerm !== "") {
      parametersURL += `filters[name][$contains]=${searchTerm}`;
    }
    if (searchTerm !== "" && selectedCategory !== "") {
      parametersURL += `&`;
    }
    if (selectedCategory !== "") {
      parametersURL += `filters[documentCategory][name][$eq]=${selectedCategory}`;
    }

    //? test
    //? console.log(searchTerm, selectedCategory);

    setFilterParameters(parametersURL);
    // nastaveni stavu podle filtru
    // 1. Oddelene pro skryti důležitých/nejčastěji stahovaných při filtrování
    // 2. CategoryLabel pro vypsani kategorie po filtrovani
    setCategoryLabel(selectedCategory);
    setSearchTerm(searchTerm);
  };

  // rekonstrukce strapi dat kategorii do jednodussiho pole
  const categoriesNames = dataCategories.data.map((categories) => ({
    id: categories.id,
    category: categories.name,
  }));

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div>
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background">
          <div className="d-flex container justify-content-center">
            <Filter
              onFilterSubmit={handleFilterSubmit}
              categories={categoriesNames}
              selectedCategory={categoryLabel}
              searchTerm={searchTerm}
            />
          </div>
          {categoryLabel === "" && searchTerm === "" && (
            <>
              <h2 className="text-center">Důležité</h2>
              <div className="container d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-center">
                {data.data.map(
                  (doc, index) =>
                    doc.important === true && (
                      <Document
                        key={index}
                        name={doc.name}
                        category={doc.documentCategory?.name}
                        fileUrl={doc.file.url}
                      />
                    )
                )}
              </div>
            </>
          )}

          <h2 className="text-center mt-5">
            {categoryLabel === "" ? "Ostatní" : categoryLabel}
          </h2>

          <div className="container d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-center pb-5">
            {data.data.map((doc, index) => (
              <Document
                key={index}
                name={doc.name}
                category={doc.documentCategory?.name}
                fileUrl={doc.file.url}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default DocumentsPage;

